// extracted by mini-css-extract-plugin
export default {"accessoriesTopNav":"vBbuc_2LDg","accessoriesNavContent":"fc747UdfAi","accessoriesBreadcrumbs":"Yn5_2ORbj3","modelBadge":"wtq03clGLf"};